import { render, staticRenderFns } from "./HeaderForm.vue?vue&type=template&id=455a27de&scoped=true"
import script from "./HeaderForm.vue?vue&type=script&lang=js"
export * from "./HeaderForm.vue?vue&type=script&lang=js"
import style0 from "./HeaderForm.vue?vue&type=style&index=0&id=455a27de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a27de",
  null
  
)

export default component.exports